import { compose, withHandlers, withState } from 'recompose';
import { debounce } from 'lodash';

import { validatePassword } from '../confirmation/actions';

const withValidatePassword = compose(
  withState('validatePasswordWarning', 'setValidatePasswordWarning', ''),
  withHandlers({
    validate: props =>
      debounce((password) => {
        validatePassword(password)
          .then(() => props.setValidatePasswordWarning(''))
          .catch(({ warning, suggestions } = {}) =>
            props.setValidatePasswordWarning(
              [warning, suggestions[0]].join(' ')
            )
          );
      }, 500),
  }),
  withHandlers({
    validatePassword: props => e => props.validate(e.target.value),
  })
);

export default withValidatePassword;



// WEBPACK FOOTER //
// ./src/app/hoc/WithValidatePassword.js